<template>
  <v-container>

    <!-- Barra superior: Filtro + Volver -->
    <v-row class="mb-8 align-center">
      <!-- Filtro -->
      <v-col cols="12" md="9">
        <div class="filter-container">
          <div class="filter-title">
            Filtrar por división
          </div>

          <v-btn-toggle
            v-model="divisionSeleccionada"
            mandatory
            class="division-toggle"
          >
            <v-btn
              v-for="div in divisiones"
              :key="div"
              :value="div"
              :class="['division-btn', `div-${div}`]"
              depressed
            >
              <div class="division-content">
                <div class="division-name">
                  {{ div }}
                </div>
                <div class="division-count">
                  {{ contadorDivisiones[div] }}
                </div>
              </div>
            </v-btn>
          </v-btn-toggle>
        </div>
      </v-col>

      <!-- Volver -->
      <v-col
        cols="12"
        md="3"
        class="d-flex justify-end align-center"
      >
        <v-btn
          color="error"
          dark
          large
          @click="volver"
        >
          Volver
        </v-btn>
      </v-col>
    </v-row>

    <!-- Layout -->
    <v-row align="start">

      <!-- Izquierda: Jugador -->
      <v-col cols="12" md="4" lg="3">
        <div class="player-sticky">
          <v-card class="player-card" elevation="6">

            <v-card-text class="text-center pb-0">
              <v-avatar size="130" class="player-avatar mb-4">
                <v-img :src="jugadores.FOTO" />
              </v-avatar>

              <div class="text-h5 font-weight-bold">
                {{ jugadores.NOMBRE }}
              </div>

              <div class="subtitle-2 grey--text mb-4">
                {{ jugadores.POSICIONES }}
              </div>
            </v-card-text>

            <v-card-text class="text-center pb-2">
              <div class="matches-box">
                <div class="matches-number">
                  {{ universidadesFiltradas.length }}
                </div>
                <div class="matches-label">
                  Universidades encontradas
                </div>
              </div>
            </v-card-text>

            <v-divider />

            <v-card-text>
              <v-row>
                <v-col cols="6" class="info-block">
                  <div class="info-label">Nivel</div>
                  <div class="info-value">{{ jugadores.NIVEL }}</div>
                </v-col>

                <v-col cols="6" class="info-block">
                  <div class="info-label">Presupuesto</div>
                  <div class="info-value">{{ jugadores.BUDGET }}</div>
                </v-col>

                <v-col cols="6" class="info-block">
                  <div class="info-label">GPA</div>
                  <div class="info-value">{{ jugadores.GPA }}</div>
                </v-col>

                <v-col cols="6" class="info-block">
                  <div class="info-label">TOEFL</div>
                  <div class="info-value">{{ jugadores.TOEFL }}</div>
                </v-col>

                <v-col cols="6" class="info-block">
                  <div class="info-label">Duolingo</div>
                  <div class="info-value">
                    {{ jugadores.DUOLINGO }}
                  </div>
                </v-col>

                <v-col cols="6" class="info-block">
                  <div class="info-label">SAT</div>
                  <div class="info-value">{{ jugadores.SAT }}</div>
                </v-col>
              </v-row>
            </v-card-text>

          </v-card>
        </div>
      </v-col>

      <!-- Derecha: Universidades -->
      <v-col cols="12" md="8" lg="9">
        <v-card
          v-for="uni in universidadesFiltradas"
          :key="uni.NOMBRE"
          outlined
          class="mb-6 university-card"
        >
          <v-card-title class="align-center">
            <v-avatar size="80" class="mr-4">
              <v-img :src="uni.LOGO" contain />
            </v-avatar>

            <div>
              <div class="text-h6">{{ uni.NOMBRE }}</div>
              <div class="text-caption grey--text">
                Division: {{ uni.DIVISIÓN }}
              </div>
            </div>
          </v-card-title>

          <v-divider />

          <v-card-text>
            <v-row>
              <v-col cols="12" sm="6" md="4" class="uni-item">
                <span class="uni-label">Posiciones:</span>
                <span class="uni-value">{{ uni.POSICIONES }}</span>
              </v-col>

              <v-col cols="12" sm="6" md="4" class="uni-item">
                <span class="uni-label">Presupuesto:</span>
                <span class="uni-value">{{ uni.BUDGET }}</span>
              </v-col>

              <v-col cols="12" sm="6" md="4" class="uni-item">
                <span class="uni-label">GPA:</span>
                <span class="uni-value">{{ uni.GPA }}</span>
              </v-col>

              <v-col cols="12" sm="6" md="4" class="uni-item">
                <span class="uni-label">TOEFL:</span>
                <span class="uni-value">{{ uni.TOEFL }}</span>
              </v-col>

              <v-col cols="12" sm="6" md="4" class="uni-item">
                <span class="uni-label">Duolingo:</span>
                <span class="uni-value">
                  {{ uni.DUOLINGO }}
                </span>
              </v-col>

              <v-col cols="12" sm="6" md="4" class="uni-item">
                <span class="uni-label">SAT:</span>
                <span class="uni-value">{{ uni.SAT }}</span>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

    </v-row>
  </v-container>
</template>


<script>
export default {
  name: 'InfoPla',

  data () {
    return {
      jugadores: {},
      universidades: [],
      jugadores_copia: [],
      universidades_copia: [],
      filter_uni: [],
      divisionSeleccionada: null,
      divisiones: ['D1', 'D2', 'NAIA', 'JUCO']
    }
  },

  mounted () {
    this.universidades = this.$route.params.universidades || []
    this.jugadores = this.$route.params.jugadores || {}
    this.universidades_copia = this.$route.params.universidades_copia || []
    this.jugadores_copia = this.$route.params.jugadores_copia || []

    this.filtrarUniversidades()
  },

  computed: {
    universidadesFiltradas () {
      if (!this.divisionSeleccionada) return this.filter_uni
      return this.filter_uni.filter(
        u => u.DIVISIÓN === this.divisionSeleccionada
      )
    },

    contadorDivisiones () {
      const base = {
        D1: 0,
        D2: 0,
        NAIA: 0,
        JUCO: 0
      }

      this.filter_uni.forEach(u => {
        if (base[u.DIVISIÓN] !== undefined) {
          base[u.DIVISIÓN]++
        }
      })

      return base
    }
  },

  methods: {
    volver () {
      this.$router.push({
        name: 'Main',
        params: {
          universidades: this.universidades_copia,
          jugadores: this.jugadores_copia
        }
      })
    },

    filtrarUniversidades () {
      const result = []
      const play = this.jugadores

      const divisiones = {
        A: ['D1', 'D2', 'NAIA', 'JUCO'],
        B: ['D2', 'NAIA', 'JUCO'],
        C: ['NAIA', 'JUCO'],
        D: ['JUCO']
      }

      const budgetMap = {
        A: ['A', 'B', 'C', 'D'],
        B: ['B', 'C', 'D'],
        C: ['C', 'D'],
        D: ['D']
      }

      const nivelesValidos = divisiones[play.NIVEL] || []
      const budgetValido = budgetMap[play.BUDGET] || []

      this.universidades.forEach(uni => {
        if (!nivelesValidos.includes(uni.DIVISIÓN)) return
        if (!budgetValido.includes(uni.BUDGET)) return

        const posUni = (uni.POSICIONES || '').split(',').map(p => p.trim())
        const posPlay = (play.POSICIONES || '').split(',').map(p => p.trim())

        if (posUni.some(p => posPlay.includes(p))) {
          result.push(uni)
        }
      })

      this.filter_uni = [...new Map(result.map(u => [u.NOMBRE, u])).values()]
    }
  }
}
</script>

<style scoped lang="scss">
/* Player */
.player-card {
  border-radius: 16px;
}

.player-avatar {
  border: 4px solid #0061ef;
}

.matches-box {
  margin: 16px auto 24px;
  padding: 16px 24px;
  background: linear-gradient(135deg, #0061ef, #1e88e5);
  border-radius: 16px;
  color: #fff;
  width: fit-content;
  min-width: 220px;
}

.matches-number {
  font-size: 3rem;
  font-weight: 800;
  line-height: 1;
}

.matches-label {
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  opacity: 0.9;
}

.info-block {
  text-align: center;
  padding: 12px 0;
}

.info-label {
  font-size: 0.75rem;
  text-transform: uppercase;
  color: #777;
  letter-spacing: 0.05em;
}

.info-value {
  font-size: 1.1rem;
  font-weight: 600;
  color: #111;
}

/* Sticky (solo desktop) */
.player-sticky {
  position: sticky;
  top: 88px;
}

@media (max-width: 960px) {
  .player-sticky {
    position: static;
  }
}

/* University */
.university-card {
  transition: box-shadow 0.2s ease;
}

.university-card:hover {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
}

.uni-item {
  display: flex;
  gap: 8px;
  font-size: 0.95rem;
}

.uni-label {
  font-weight: 600;
  color: #555;
}

.uni-value {
  color: #000;
}
.filter-container {
  background: #f8f9fc;
  border-radius: 14px;
  padding: 16px 20px;
  display: inline-block;
}

.filter-title {
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #666;
  margin-bottom: 12px;
}

.division-toggle {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.division-btn {
  border-radius: 20px;
  font-weight: 600;
  min-width: 80px;
  transition: all 0.2s ease;
}

/* ===== COLORES POR DIVISION ===== */

.div-D1 {
  color: #1e88e5;
  border: 1px solid #1e88e5;
}

.div-D2 {
  color: #43a047;
  border: 1px solid #43a047;
}

.div-NAIA {
  color: #fb8c00;
  border: 1px solid #fb8c00;
}

.div-JUCO {
  color: #8e24aa;
  border: 1px solid #8e24aa;
}

/* ===== ACTIVO ===== */

.division-btn.v-btn--active {
  color: #fff !important;
}

.div-D1.v-btn--active {
  background-color: #1e88e5;
}

.div-D2.v-btn--active {
  background-color: #43a047;
}

.div-NAIA.v-btn--active {
  background-color: #fb8c00;
}

.div-JUCO.v-btn--active {
  background-color: #8e24aa;
}

.division-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1.1;
}

.division-name {
  font-size: 0.85rem;
  font-weight: 700;
}

.division-count {
  font-size: 0.7rem;
  opacity: 0.8;
  margin-top: 2px;
}

</style>
